module.exports = __webpack_public_path__ + "static/city_step03-171f052cbc034e7e6d0737d38761df25.png";